module.exports = __webpack_public_path__ + "static/media/Purchase4.f8799715.png";